import {cn, cva} from 'platform/shared';

import {suffixTestId, TestIdProps} from 'shared/web';

import {useFoundationTheme} from '../../hooks/useFoundationTheme';
import {SpinnerColor} from '../../types/SpinnerColor';
import {SpinnerSize} from '../../types/SpinnerSize';
import {SpinnerVariant} from '../../types/SpinnerVariant';
import {getColorByPath} from '../../utils/getColorByPath';
import {getSize} from '../../utils/getSize';
import './Spinner.css';

const spinnerVariants = cva(
  'block animate-[rotate_1s_linear_infinite] [&_circle]:animate-[dash_1.5s_ease-in-out_infinite] [&_circle]:[stroke-linecap:round]'
);

const spinnerOverlayVariants = cva(
  'absolute inset-0 flex h-full w-full items-center justify-center'
);

export interface SpinnerProps extends TestIdProps {
  size?: SpinnerSize;
  variant?: SpinnerVariant;
  color?: SpinnerColor;
}

export function Spinner(props: SpinnerProps) {
  const theme = useFoundationTheme();
  const cssSize = getSize(theme.components.Spinner.size[props.size ?? 'default']);
  const spinner = (
    <svg
      id="spinner"
      className={cn(spinnerVariants())}
      style={{
        width: cssSize,
        height: cssSize,
      }}
      viewBox="0 0 50 50"
      data-testid={suffixTestId('spinner', props)}
    >
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        strokeWidth={theme.components.Spinner.thickness[props.size ?? 'default']}
        style={{
          stroke: getColorByPath(theme.components.Spinner.color[props.color ?? 'dark'], theme),
        }}
      />
    </svg>
  );

  if (props.variant === 'overlay') {
    return (
      <div
        className={cn(spinnerOverlayVariants())}
        style={{background: theme.colors.palettes.white[10][80]}}
        data-testid={suffixTestId('spinner-overlay', props)}
      >
        {spinner}
      </div>
    );
  }

  return spinner;
}
